<template>
    <div class="specialView-container">
        <section class="specialView-image_container aval-color">
            <span class="aval-image"></span>
        </section>
        <section class="specialView-info_container">
            <h2 class="specialView-info_title"> Ups, no podemos continuar</h2>
            <p class="specialView-info_text">
                Para seguir con la simulación de tu hipoteca, es necesario contar con un aval (propiedad propia o familiar sin cargas)
                o una aportaión de dinero. Sin esta garantía no podemos avanzar en el proceso.
                Por favor, verifica si puedes aportar un aval y vuelve a intentarlo.
            </p>
            <div class="avalko-action_container">
                <button class="button tertiary rounded" @click="goBegining()" >
                    Volver a intentarlo
                </button>
                <button class="button primary rounded" @click="goEnd()" >
                    Entendido
                </button>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'avalKO',
    mounted() {
        window.scrollTo(0, 0);
    },
    methods: {
        goEnd() {
            window.location.href = 'https://myinvestor.es/hipotecas/';       
        },
        goBegining() {
            this.$store.dispatch('goNext', 'step_productos');
        }
    }
}
</script>

<style scoped>
    .aval-color {
        background: #FEE5E5;
    }
    .aval-image {
        width: 400px ;
        height: 400px;
        background: url(../../assets/taza_rosa.png) center ;
    }
    .avalko-action_container {
        display: flex;
        justify-content: flex-start;
        gap: 16px;
    }
    /* MOVIL */
    @media (max-width: 768px) {
        /* .aval-image {
            background: url(../../assets/taza_rosa.png) center / contain no-repeat ;
        } */
        .avalko-action_container {
            flex-direction:  column;
            width: 100%;
        } 
    }

</style>
